export default __webpack_public_path__ + "static/media/Start_pandemic.80006c29.png";